import { useMemo } from 'react'
import { extractGroups, extractRoles } from '../../../auth/claims'
import { getIamPortalOrigin } from '../../../auth/portal'
import { loadSession } from '../../../auth/state'
import { useI18n } from '../../../utils/i18n'

export default function Access() {
  const { tx } = useI18n()
  const session = useMemo(() => loadSession(), [])
  const iamPortal = useMemo(() => getIamPortalOrigin(), [])
  const roles = extractRoles(session)
  const groups = extractGroups(session)

  return (
    <div className="space-y-4">
      <div className="bg-brand-surface rounded-3xl p-6 border-2 border-brand-textDark/10 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)]">
        <div className="text-brand-textDark font-extrabold text-lg">Access</div>
        <div className="text-brand-text font-bold text-sm mt-1">
          {tx({ zh: '基于 IAM 的 roles + groups 控制菜单/权限。', en: 'Menu and permissions are controlled by IAM roles + groups.' })}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-brand-surface rounded-3xl p-6 border-2 border-brand-textDark/10 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)]">
          <div className="text-brand-textDark font-extrabold">Roles</div>
          <div className="mt-3 text-brand-textDark font-black break-words">{roles.length ? roles.join(', ') : '(none)'}</div>
          <div className="mt-4 text-brand-text font-bold text-sm">
            {tx({ zh: '约定默认 4 个角色：', en: 'Default roles:' })}{' '}
            <span className="font-black">superadmin</span>, <span className="font-black">admin</span>, <span className="font-black">parent</span>,{' '}
            <span className="font-black">child</span>
          </div>
        </div>

        <div className="bg-brand-surface rounded-3xl p-6 border-2 border-brand-textDark/10 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)]">
          <div className="text-brand-textDark font-extrabold">Groups</div>
          <div className="mt-3 text-brand-textDark font-black break-words">{groups.length ? groups.join(', ') : '(none)'}</div>
          <div className="mt-4 text-brand-text font-bold text-sm">
            {tx({ zh: 'parent/child 通过 groups（family）做范围控制。', en: 'parent/child scope is controlled via groups (family).' })}
          </div>
        </div>

        <div className="bg-brand-surface rounded-3xl p-6 border-2 border-brand-textDark/10 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)]">
          <div className="text-brand-textDark font-extrabold">Manage</div>
          <div className="mt-3 text-brand-text font-bold text-sm">
            {tx({ zh: '角色与用户绑定目前在 IAM Admin 配置：', en: 'Role/user bindings are configured in IAM Admin:' })}{' '}
            <a className="text-brand-cyan hover:underline font-black" href={iamPortal} target="_blank" rel="noreferrer">
              {iamPortal}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
